import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const FeedbackPopup = (props) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    feedbackType: "Bug",
    subject: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    const success = await props.createCommands.submitFeedback(formData);
    setSubmitting(false);
    if (success) {
      setShowSuccess(true);
      setTimeout(() => {
        props.tierListFunctions.displayPopup("");
      }, 1500);
    }
  };

  return (
    <>
      <Dialog id="feedback-popup" open={true} onClose={() => props.tierListFunctions.displayPopup("")} fullWidth maxWidth="sm">
        <DialogTitle>{t("feedback.title")}</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            {t("feedback.description")}
          </Typography>
          <FormControl fullWidth margin="dense">
            <InputLabel>{t("feedback.type")}</InputLabel>
            <Select name="feedbackType" value={formData.feedbackType} onChange={handleChange} label={t("feedback.type")}>
              <MenuItem value="Bug">{t("feedback.bug")}</MenuItem>
              <MenuItem value="Suggestion">{t("feedback.suggestion")}</MenuItem>
              <MenuItem value="General">{t("feedback.general")}</MenuItem>
            </Select>
          </FormControl>
          <TextField
            autoFocus
            margin="dense"
            label={t("feedback.subject")}
            name="subject"
            fullWidth
            variant="outlined"
            value={formData.subject}
            onChange={handleChange}
            inputProps={{ maxLength: 255 }}
          />
          <TextField
            margin="dense"
            label={t("feedback.message")}
            name="message"
            fullWidth
            variant="outlined"
            multiline
            rows={4}
            value={formData.message}
            onChange={handleChange}
            inputProps={{ maxLength: 5000 }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              props.tierListFunctions.displayPopup("");
            }}
            color="primary"
          >
            {t("feedback.cancel")}
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            disabled={!formData.subject.trim() || !formData.message.trim() || submitting}
          >
            {t("feedback.submit")}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={showSuccess} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert severity="success" variant="filled">
          {t("feedback.success")}
        </Alert>
      </Snackbar>
    </>
  );
};

export default FeedbackPopup;
